import { render, staticRenderFns } from "./MarketGroupStatus.vue?vue&type=template&id=ed62a7f4&"
import script from "./MarketGroupStatus.vue?vue&type=script&lang=js&"
export * from "./MarketGroupStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports